import "./StratingSteps.scss";

interface StepsProps {
    stepsArr: {
        title: string;
        description: string;
    }[];
    icon: string;
    title: string;
}

const StratingSteps = ({ stepsArr, icon, title }: StepsProps) => {
  return (
    <div className="starting-steps-container">
      <div className="icon-area">
        <img src={icon} alt="icon" />
        <div className="title">{title}</div>
      </div>
      <div className="steps-description">
        {stepsArr.map((step, index) => {
          return (
            <div className="step-row" key={index}>
              <div className="step-count">{index + 1}</div>
              <div className="step">
                <div className="step-title">{step.title}</div>
                <div className="step-text">{step.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default StratingSteps;
